import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { goalTemplatesSearchSchema } from "./-lib/search-schema";



export const Route = createFileRoute("/_protected/goals/templates/")({
  head: () => ({
    meta: [{ title: "目标模板配置 · imiker CRM" }],
  }),
  validateSearch: goalTemplatesSearchSchema,
  search: {
    middlewares: [stripSearchParams({ level: "D" as const })],
  }
});
